import React from "react";
import { string } from "yup";
import Input from "./Base";
const nameRegex = /^(?:[a-z])*[a-z](?:[ '-][a-z]+)*$/i;
const nameLengthMessage = "Last name must be between 2 and 30 characters long.";
const specialCharacterMessage = "Last name cannot end with a special character.";
export const schema = string().required("A last name is required.").min(2, nameLengthMessage).matches(nameRegex, specialCharacterMessage).max(30, nameLengthMessage);
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ref,
  label: "Last Name",
  required: true,
  ...props
}));
